module.exports = __webpack_public_path__ + "assets/icons/preferences.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/preferences.png
// module id = ./src/styles/icons/sidemenu/preferences.png
// module chunks = 0